module.exports = __webpack_public_path__ + "img/eldorado.f76eb793.svg";